import { Avatar, Button, Card, Space, Table, Tag, Tooltip } from 'antd';
import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../Utility/PageTitle';
import { useNavigate } from 'react-router-dom';
import { formatDate, getApplicationType, getStatusTag, getApplicationId, formatDateTime } from '../../Utility/Functions';
import { ArrowRightOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import AdvancedTable from '../../Utility/AdvancedTable';
import { useFetch } from '../../../services/ApiService';

function ApplicationList() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { fetchApi } = useFetch();

    const getData = async () => {
        setLoading(true);
        await fetchApi('/api/application', 'GET').then(res => {
            setData(res);
        }).catch(err => {
            console.log(err);
        })
        setLoading(false);
    }

    const columns = [
        {
            columnTitle: <Tooltip title='Application Number'>App. No</Tooltip>,
            dataIndex: 'id',
            key: 'id',
            width: 120,
            className: 'text-center fw-semibold',
            customRender: (value) => getApplicationId(value)
        },
        {
            columnTitle: 'Candidate Name',
            dataIndex: 'candidate_name',
            key: 'candidate_name',
            width: 250,
            customRender: (value, record) => (
                <div className='avatar-user py-0'>
                    <Avatar size={40} src={record.image_url} />
                    <div className='avatar-user-info'>
                        <h6 className='mb-0'>{value}</h6>
                    </div>
                </div>
            ),

        },
        {
            columnTitle: 'Aadhar No.',
            dataIndex: 'aadhar_number',
            className: 'fw-semibold',
            key: 'aadhar_number',
            responsive: ['lg']
        },
        {
            columnTitle: 'Type',
            dataIndex: 'application_type',
            key: 'application_type',
            className: 'text-center',
            width: 80,
            customRender: (value) => getApplicationType(value),
            responsive: ['lg']
        },

        {
            columnTitle: 'Status',
            key: 'status',
            dataIndex: 'status',
            className: 'text-center hide-icon',
            width: 160,
            customRender: (value) => getStatusTag(value, true),
            responsive: ['lg']
        },
        {
            columnTitle: 'Superviser',
            key: 'supervisor_name',
            dataIndex: 'supervisor_name',
            className: 'fw-semibold',
            responsive: ['lg']
        },
        {
            columnTitle: 'Unit',
            key: 'unit_name',
            dataIndex: 'unit_name',
            className: 'fw-semibold'
        },
        {
            columnTitle: 'Trade',
            key: 'job_trade',
            dataIndex: 'job_trade',
            className: 'fw-semibold'
        },
        {
            columnTitle: 'Application Date',
            key: 'application_date',
            dataIndex: 'application_date',
            className: 'text-center',
            width: 170,
            customRender: (value) => formatDateTime(value)
        },
        {


            className: 'text-center',

            customRender: (value) => <ArrowRightOutlined />/* {
                return (
                    <div className='d-flex justify-content-center'>
                        
                        <Tooltip title="View Details">
                            <Button className='me-2 rounded-btn-icon' size="small" onClick={() => navigate(`${value}`)}><EyeOutlined /></Button>
                        </Tooltip>
                        <Tooltip title="Edit Details">
                            <Button size="small" className='rounded-btn-icon' onClick={() => navigate(`/create-application/edit/${value}`)}><EditOutlined /></Button>
                        </Tooltip>
                    </div>
                )
            } */
        },
    ];

    useEffect(() => {
        getData();
    }, [])


    return (
        <>
            <PageTitle title="My Applications" />
            <Card className='mt-5'>
                {/* <Table
                    loading={loading}
                    className='custom-table'
                    columns={columns}
                    dataSource={data}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: (event) => navigate(`${record.id}`), // click row
                        };
                    }}
                /> */}
                <AdvancedTable
                    noSr
                    editable={false}
                    //refreshData={reloadData}
                    //refreshDataButton={true}
                    loading={loading}
                    data={data}
                    columns={columns}
                    customColumns={false}
                    title={<h5 className='mb-2'>All Applications</h5>}
                    //defaultFilter={statusFilter}
                    //defaultFilterKey='status'
                    exportable={false}
                    onRowClick={(e, record) => {
                        navigate(`${record.id}`)
                    }}
                />
            </Card>
        </>
    )
}

export default ApplicationList